import { css } from "lit";

export const styles = css`
  :host {
    display: inline-flex;
    align-items: center;
    position: relative;
  }

  .bars {
    display: flex;
    align-items: flex-end;
    gap: 2px;
    cursor: pointer;
    padding: 4px;
  }

  .bar {
    width: 4px;
    border-radius: 1px;
    transition: background-color 0.3s ease;
  }

  .bar-1 {
    height: 6px;
  }

  .bar-2 {
    height: 10px;
  }

  .bar-3 {
    height: 16px;
  }

  .bar.inactive {
    background-color: var(--sds-color-border-default-default, #555);
  }

  .bar.excellent,
  .bar.good {
    background-color: var(--sds-color-background-success-default, #22c55e);
  }

  .bar.moderate {
    background-color: var(--sds-color-background-warning-default, #eab308);
  }

  .bar.poor {
    background-color: var(--sds-color-background-danger-default, #f97316);
  }

  .bar.critical {
    background-color: var(--sds-color-background-danger-default, #ef4444);
    animation: pulse-bar 1s ease-in-out infinite;
  }

  .bar.warmup {
    background-color: var(--sds-color-text-default-secondary, #888);
  }

  @keyframes pulse-bar {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
  }

  .tooltip {
    display: none;
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    background: rgb(0 0 0 / 0.9);
    color: #fff;
    padding: 8px 12px;
    border-radius: 6px;
    font: var(--sds-typography-weight-regular) 11px/1.4 var(--sds-typography-family-mono);
    white-space: nowrap;
    z-index: 10;
    pointer-events: none;
  }

  .tooltip::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-top-color: rgb(0 0 0 / 0.9);
  }

  .bars:hover + .tooltip,
  .bars:focus + .tooltip {
    display: block;
  }

  .tooltip-row {
    display: flex;
    justify-content: space-between;
    gap: 12px;
  }

  .tooltip-label {
    color: rgb(255 255 255 / 0.7);
  }

  .tooltip-value {
    color: #fff;
    text-align: right;
  }
`;
